module.exports = __webpack_public_path__ + "static/img/6756_phase_function_Paper_Points.22e33fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6756_phase_function_Paper_Points.png
// module id = 9v6S
// module chunks = 0